import Router from '@utils/router'

new Router([
    {
        file: 'pages/main'
    },
    {
        file: 'pages/search',
        resolve: '.search'
    }
]).load()